import { LocalStorageAdapter } from '@pp/toolkit';

import { Logger } from '../../logger/Logger';

export const LocalStorage = new LocalStorageAdapter();

LocalStorage.addEventListener('error', (key, operation) => {
  Logger.logFailure('localStorage', {
    place: operation,
    additional: key,
  });
});
